import React from 'react'
import "../styles/Banner.css"

const Banner = () => {
    return (
        <div className="Banner">
            <p>
                <b>Try it free 7 days</b> then $20/mo. thereafter
            </p>
        </div>
    );
}

export default Banner